import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/analytics/analytics.service';
import { AnalyticsEvent } from 'src/app/analytics/models/analytics-event';
import { AuthService } from 'src/app/auth/auth.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly loader: LoaderService,
        private readonly notificationService: NotificationService,
        private readonly analytics: AnalyticsService
    ) { }

    ngOnInit() {
        this.loader.show();
        this.notificationService.stopAutoRefresh();
        if (this.authService.isLoggedIn()) {
            this.endSession()
            this.authService.logout();
            return;
        }

        this.router.navigate(['/']).then(() => {
            this.loader.hide();
        });
    }

    async endSession(): Promise<void> {
        await this.analytics.track(AnalyticsEvent.SessionEnd, {
            ...this.analytics.globalProps()
        });
    }
}
